import styled from "styled-components";

export const ScBikesCalculatorHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 50px;
`;

export const ScBikesCalculatorLogo = styled.img`
  margin-top: 13px;
`;
